import { createContext as e, useState as t, useMemo as n, useCallback as a, useEffect as r, useContext as i } from "react";

import { useProviderSchedule as l } from "./useProviderSchedule.js";

import o from "../components/AvailabilityDrawer/IndexStepContent/index.js";

import d from "../components/AvailabilityDrawer/DateRangeAndRepeatStepContent.js";

import s from "../components/AvailabilityDrawer/DaysAndTimeStepContent/index.js";

import m from "../components/AvailabilityDrawer/ViewSlotsStepContent/index.js";

const p = {
    index: 0,
    dateRangeAndRepeat: 1,
    daysAndTime: 2,
    viewSlots: 3
}, u = {
    [p.index]: o,
    [p.dateRangeAndRepeat]: d,
    [p.daysAndTime]: s,
    [p.viewSlots]: m
}, w = () => {
    const [e, i] = t(null), {submitSchedule: o, drawerSlotsFilter: d, schedulesMap: s} = l(), [m, w] = t(!1), A = n((() => d ? p.viewSlots : p.index), [ d ]), [S, c] = t(A), [v, R] = t(), C = n((() => new Intl.DateTimeFormat("en-US", {
        timeZoneName: "short"
    }).formatToParts(new Date).find((e => "timeZoneName" === e.type))?.value || ""), []), b = n((() => u[S] || null), [ S ]), y = n((() => e && s?.[e] || null), [ e, s ]), h = a((e => () => {
        w(!!e);
    }), []), x = a((e => {
        i(e || null), c(p.dateRangeAndRepeat);
    }), []), D = a((() => {
        c(p.index), R(null), i(null), h(!1)();
    }), [ h ]), T = a((e => {
        R(e), c(p.daysAndTime);
    }), []), g = a((e => {
        o?.({
            ...e,
            id: y?.id
        });
    }), [ y?.id, o ]);
    r((() => {
        c((e => e !== A ? A : e));
    }), [ A ]);
    const f = n((() => [ p.index, p.viewSlots ].includes(S) ? "Manage Availability" : (y ? "Edit" : "Add New") + " Availability"), [ S, y ]);
    return {
        currentStep: S,
        setCurrentStep: c,
        currentTimezone: C,
        Content: b,
        initFlow: x,
        resetFlow: D,
        saveDateRangeAndRepeat: T,
        dateRangeAndRepeatValues: v,
        submitAvailability: g,
        editableSchedule: y,
        showCreateError: h(!0),
        hideCreateError: h(!1),
        hasCreateError: m,
        drawerTitle: f
    };
}, A = e({
    currentStep: 0,
    setCurrentStep: () => {},
    currentTimezone: "",
    Content: () => null,
    initFlow: () => {},
    resetFlow: () => {},
    saveDateRangeAndRepeat: () => {},
    dateRangeAndRepeatValues: null,
    submitAvailability: () => {},
    editableSchedule: null,
    showCreateError: () => {},
    hideCreateError: () => {},
    hasCreateError: !1,
    drawerTitle: ""
}), S = () => i(A);

export { p as CREATE_AVAILABILITY_STEPS, A as CreateAvailabilityContext, w as useCreateAvailability, S as useCreateAvailabilityFlow };
//# sourceMappingURL=useCreateAvailability.js.map
